import { MutationModal } from './MutationModal'
import { CIMSModalWrapperProps } from '../../CIMSModal/types'
import { useCIMSTableContext } from '../CIMSTableContext'

function SimpleEditModal<T extends object>({
  onClose,
  visible,
  state,
}: CIMSModalWrapperProps<T>) {
  const { actions } = useCIMSTableContext<T>()
  const { modal } = actions.row?.edit ?? {}
  if (!modal || !state) return null
  let name
  if (modal.type !== 'custom') {
    if (typeof modal.recordName === 'function') name = modal.recordName(state)
    else name = state[modal.recordName]
  }
  return (
    <MutationModal
      onClose={onClose}
      title={`Edit ${name}`}
      visible={visible}
      modal={
        modal.type === 'custom'
          ? { type: 'custom', props: { ...modal, record: state, type: 'edit' } }
          : { type: 'simple', props: { ...modal, record: state, type: 'edit' } }
      }
    />
  )
}

export default SimpleEditModal
